import React, { useState } from 'react';

import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { t } from 'i18next';
import { Close } from '@mui/icons-material';
import { useFormik } from 'formik';

import styles from './EmployerContactDetail.module.css';
import Button from '../../Buttons/Button/Button';
import FormField from '../../UpdatedFormUI/FormField/FormField';
import FormSelectField from '../../UpdatedFormUI/FormSelectField/FormSelectField';
import { EditIcon } from '../../../../assets/images/icons'; // Replace with correct import for the icon
import { updateUser } from '../../../../services/userService';
import { fetchUserByToken, fetchUserByTokenWithoutLoading } from '../../../../app/features/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCitiesOfState, useGetStates } from '../../../../utils/utilityHooks';
import { useNavigate } from 'react-router-dom';
import Notice from '../Notice/Notice';

function EmployerContactDetail({ employer }) {
    const user = useSelector(state => state.user.user);
    const [formLoading, setFormLoading] = useState(false);
    const [editMode, setEditMode] = useState(true)
    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const formik = useFormik({
        initialValues: {
            country: user?.country || '',
            state: user?.state || '',
            Address_Line_1: user?.Address_Line_1 || '',
            Address_Line_2: user?.Address_Line_2 || '',
            city: user.city || '',
            postalCode: user.postalCode || '',
            company_email_address: user.employer_status !== 'business' ? user.email : user.company_email_address || '',
            phone: user.employer_status !== 'business' ? user.mobile_number : user.phone || '',
        },
        validationSchema: Yup.object({
            company_email_address: Yup.string().email(t('forms.welcome_employer.invalidEmail')).required(t('forms.welcome_employer.required')),
        }),
        onSubmit: (values) => {
            if (formLoading) {
                return;
            }
            setFormLoading(true);
            const formData = new FormData();
            formData.append('token', userToken);
            formData.append('country', values.country);
            formData.append('Address_Line_1', values.Address_Line_1);
            formData.append('Address_Line_2', values.Address_Line_2);
            formData.append('city', values.city);
            formData.append('state', values.state);
            formData.append('postalCode', values.postalCode);

            if (user.employer_status !== 'business') {
                if (user.email !== values.company_email_address) {
                    formData.append('email', values.company_email_address);
                }
            } else {
                formData.append('company_email_address', values.company_email_address);
            }

            if (user.employer_status !== 'business') {
                formData.append('mobile_number', values.phone);

            } else {
                formData.append('phone', values.phone);

            }
            formData.append('company_name', employer.company_name);
            formData.append('first_name', employer.first_name);
            formData.append('last_name', employer.last_name);


            toast.promise(updateUser(formData), {
                loading: t('edit_profile.updating_profile'),
                success: <b>{t('edit_profile.profile_updated')}</b>,
                error: (err) => <b>{err.response.data.error}</b>,
            }).then(async () => {
                if (employer.employer_status == 'business') {
                    await dispatch(fetchUserByTokenWithoutLoading(userToken));
                    const target = document.querySelector('.formScroll');
                    if (target) {
                        window.scrollTo({
                            top: target.offsetTop,
                            behavior: 'smooth'
                        });
                    }
                    await setEditMode(!editMode)
                    await setFormLoading(false);
                } else {
                    await dispatch(fetchUserByTokenWithoutLoading(userToken));
                    const target = document.querySelector('.formScroll');
                    if (target) {
                        window.scrollTo({
                            top: target.offsetTop,
                            behavior: 'smooth'
                        });
                    }
                    await setEditMode(!editMode)
                    await setFormLoading(false);
                }
            })
                .catch((error) => {
                    setFormLoading(false);
                    if (error?.response?.data?.field) {
                        formik.setErrors({
                            [error.response.data.field]: error.response.data.error
                        });
                    }
                });
        },
    });

    const citiesOptions = useGetCitiesOfState(formik.values.state);
    const statesOptions = useGetStates(formik.values.country);

    return (
        <div className={styles.container}>
            {/* Second Column */}
            <div className={styles.secondColumn}>
                {!editMode &&
                    <Close
                        className={styles.mobileIcon}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => { setEditMode(!editMode) }}
                    />}
                <div className={`${styles.title} formScroll`}>
                    {t(`profileSidebar.tabs.contactDetails`)}
                </div>
                <div className={styles.aboutTitle}></div>

                {editMode ?
                    <>
                        {/* Address Line 1 */}
                        {/* {user.Address_Line_1 && */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.AddressLine1')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.Address_Line_1 ? `${user.Address_Line_1}` : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* } */}

                        {/* Address Line 2 */}
                        {/* {user.Address_Line_2 && */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.AddressLine2')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.Address_Line_2 ? `${user.Address_Line_2}` : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* } */}

                        {/* Country */}
                        {/* {user.country && */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.Country')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user?.country ? t('general.country.' + user.country) : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* } */}

                        {/* State */}
                        {/* {user.state && */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.State')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.state
                                    ? /^[a-z_]+$/.test(user.state.toLowerCase())
                                        ? t('general.state.' + user.state)
                                        : user.state
                                    : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* } */}

                        {/* City */}
                        {/* {user.city && */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.City')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.city
                                    ? /^[a-z_]+$/.test(user.city.toLowerCase())
                                        ? t('general.city.' + user.city)
                                        : user.city
                                    : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* } */}

                        {/* Postal Code */}
                        {/* {user.postalCode && <> */}
                        <>
                            <div className={styles.aboutTitle}>{t('general.postalCode')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.postalCode ? `${user.postalCode}` : t('jobPreferences.jobTitlesSection.notSpecified')}
                            </div>
                        </>
                        {/* // } */}

                        {/* company_email_address */}
                        {user.employer_status !== 'business' ?
                            <>
                                <div className={styles.aboutTitle}>{t('general.email')}</div>
                                <div className={`${styles.description} ${styles.fullWidth}`} style={{ textTransform: "none" }}>
                                    {user.email ? `${user.email}` : t('jobPreferences.jobTitlesSection.notSpecified')}
                                </div>
                            </>
                            :
                            // user.company_email_address &&
                            <>
                                <div className={styles.aboutTitle}>{t('general.company_email_address')}</div>
                                <div className={`${styles.description} ${styles.fullWidth}`} style={{ textTransform: "none" }}>
                                    {user.company_email_address ? `${user.company_email_address}` : t('jobPreferences.jobTitlesSection.notSpecified')}
                                </div>
                            </>
                        }

                        {/* Phone */}
                        {/* {user.phone && */}
                        <>

                            <div className={styles.aboutTitle}>{user.employer_status !== 'business' ? t('general.phone') : t('general.company_phone_number')}</div>
                            <div className={`${styles.description} ${styles.fullWidth}`}>
                                {user.employer_status !== 'business' ?
                                    user.mobile_number ? `${user.mobile_number}` : ''
                                    :
                                    user.phone ? `${user.phone}` : t('jobPreferences.jobTitlesSection.notSpecified')
                                }
                            </div>
                        </>
                        {/* } */}
                    </>
                    :
                    <>
                        <div>
                            <FormField
                                name="Address_Line_1"
                                type="text"
                                hasBorder
                                label={t('forms.welcome_address.AddressLine1')}
                                placeholder={t('forms.welcome_address.AddressLine1')}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.Address_Line_1}
                                error={formik.touched.Address_Line_1 && formik.errors.Address_Line_1}
                            />
                        </div>
                        <div>
                            <FormField
                                name="Address_Line_2"
                                type="text"
                                label={t('forms.welcome_address.AddressLine2')}
                                placeholder={t('forms.welcome_address.AddressLine2')}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                hasBorder
                                value={formik.values.Address_Line_2}
                                error={formik.touched.Address_Line_2 && formik.errors.Address_Line_2}
                            />
                        </div>
                        <div>
                            <FormSelectField
                                name="country"
                                type="country"
                                label={t('general.Country')}
                                placeholder={t('general.Country')}
                                onFormikChange={formik.handleChange}
                                hasBorder
                                options={['QA', 'AE', 'SA', 'BH', 'KW', 'OM']}
                                value={formik.values.country}
                                error={formik.touched.country && formik.errors.country}
                            />
                        </div>
                        {formik.values.country &&
                            <div>
                                <FormSelectField
                                    name="state"
                                    hasBorder
                                    type="default"
                                    label={t('general.State')}
                                    placeholder={t('general.State')}
                                    options={statesOptions}
                                    onFormikChange={formik.handleChange}
                                    value={formik.values.state}
                                    error={formik.touched.state && formik.errors.state}
                                />
                            </div>
                        }
                        {formik.values.state &&
                            <div>
                                <FormSelectField
                                    name="city"
                                    hasBorder
                                    type="default"
                                    label={t('general.City')}
                                    placeholder={t('general.City')}
                                    options={citiesOptions}
                                    onFormikChange={formik.handleChange}
                                    value={formik.values.city}
                                    error={formik.touched.city && formik.errors.city}
                                />
                            </div>
                        }
                        <div>
                            <FormField
                                name="postalCode"
                                type="text"
                                label={t('general.postalCode')}
                                placeholder={t('general.postalCode')}
                                hasBorder
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                maxLength={10}
                                value={formik.values.postalCode}
                                error={formik.touched.postalCode && formik.errors.postalCode}
                            />
                        </div>
                        <div>
                            {user.employer_status !== 'business' ?
                                <>
                                    <FormField
                                        name="company_email_address"
                                        type="company_email_address"
                                        label={t('edit_profile.job_seeker.email')}
                                        hasBorder
                                        icon={user.email_verified && formik.values.email === user.email && 'verified'}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.company_email_address}
                                        error={formik.touched.company_email_address && formik.errors.company_email_address}
                                    />
                                    {!user.email_verified && <Notice warning>{t('edit_profile.job_seeker.email_notice')}</Notice>}

                                </>
                                :
                                <FormField
                                    name="company_email_address"
                                    type="company_email_address"
                                    label={t('general.company_email_address')}
                                    placeholder={t('general.company_email_address')}
                                    hasBorder
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.company_email_address}
                                    error={formik.touched.company_email_address && formik.errors.company_email_address}
                                />
                            }
                        </div>

                        <div>
                            <FormField
                                name="phone"
                                type="text"
                                label={user.employer_status !== 'business' ? t('general.phone') : t('general.company_phone_number')}
                                placeholder={user.employer_status !== 'business' ? t('general.phone') : t('general.company_phone_number')}
                                hasBorder
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.phone}
                                error={formik.touched.phone && formik.errors.phone}
                            />
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button onClick={formik.submitForm} className={styles.saveButton} >
                                {formLoading ? t('general.UI.loading') : t('general.UI.save')}
                            </Button>
                        </div>
                    </>
                }
            </div>
            <div className={styles.thirdColumn}>
                {!editMode ?
                    <Close
                        className={styles.crossIcon}
                        style={{
                            cursor: "pointer"
                        }}
                        onClick={() => { setEditMode(!editMode) }}
                    /> :

                    <img
                        src={EditIcon}
                        onClick={() => setEditMode(!editMode)}
                        alt={t('personalInformation.edit')}
                        className={styles.editIcon}
                    />
                }
            </div>
        </div >
    );
}

export default EmployerContactDetail;
